import { InformationAccordion } from '@/components/elements/information-accordion/information-accordion.component';
import { NoResults } from '@/components/elements/no-results/no-results.component';
import { Information, ProductBuildingBlock } from '@/gql/graphql';
import { pretailoringPageMessages } from '@/pages/products/pre-tailoring/pre-tailoring.messages';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  bb: ProductBuildingBlock;
}

export const InformationTab = ({ bb }: Props) => {
  const t = useIntl();

  const gatherBBInformation = useCallback(
    (bb: ProductBuildingBlock) => {
      const informations: Information[] = [...bb.informations];
      const bbInformations = bb.dataBlocks.map((db) => db.informations).flat();
      const doInformations = bb.designObligation?.informations || [];
      return Array.from(
        new Map([...informations, ...bbInformations, ...doInformations].map((item) => [item.id, item])).values(),
      );
    },
    [bb],
  );

  return (
    <div className="flex flex-col w-full gap-y-2" data-testid="building-block-details-information-content">
      <div className="w-full flex justify-center items-center">
        {gatherBBInformation(bb).length === 0 && (
          <NoResults message={t.formatMessage(pretailoringPageMessages.singleBuildingBlockTabNoInformation)} />
        )}
      </div>
      {gatherBBInformation(bb).length > 0 && (
        <InformationAccordion data={gatherBBInformation(bb)} testIdContext="building-block-details" />
      )}
    </div>
  );
};
